<template>
  <div class="error-component">
    <h3 class="text-md mt-8 lg:text-lg lg:mt-10">
      {{ subtext }}
      <a
        class="hover:text-ternBlue cursor-pointer"
        href="mailto:tavishi@travelwithtern.com?subject=Unable to join the waitlist"
        >tavishi@travelwithtern.com</a
      >.
    </h3>
    <div class="mt-8">
      <StarButton text="Try again" @click="goBack" />
    </div>
  </div>
</template>

<script>
import StarButton from '@/components/Buttons/StarButton.vue';

export default {
  name: 'Error',
  components: {
    StarButton,
  },
  data() {
    return {
      subtext: 'Uh oh — glitch in the matrix. Try again, or email ',
    };
  },
  methods: {
    goBack() {
      this.$emit('form-completed', undefined);
    },
  },
};
</script>
